module.exports = __webpack_public_path__ + "static/media/ic_rectangle_selected.7ac195ed.svg";